export default "__VITE_PUBLIC_ASSET__dfe90a87__"